module.exports = __webpack_public_path__ + "static/img/newLogo.fcdb9e8.png";